// @flow
import Alert from 'components/billboard/Alert';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/billboard/Alert';
import { setShowAlertInfo } from 'actions/appActions';

export default connect(
  (state: StateType): StateProps => ({
    showAlertInfo: state.appState.showAlertInfo,
    message_alerte: state.settingsState.message_alerte,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    closeAlertInfo: (raw: string) => dispatch(setShowAlertInfo(raw))
  })
)(Alert);
